module.exports = __webpack_public_path__ + "static/kazuha-selected-bea20980d6f2bd807ba1cdfaa1f297b6.png";